import { render, staticRenderFns } from "./window-secondary.vue?vue&type=template&id=ee203e32&scoped=true&"
import script from "./window-secondary.vue?vue&type=script&lang=js&"
export * from "./window-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee203e32",
  null
  
)

export default component.exports